import { Alert, Box, Button, Flex, Group, SimpleGrid, Text, TextInput } from "@mantine/core";
import { useState } from "react";
import { SectionCard } from "../HomeBlockShared";
import { BannerConfig } from "../homeBlockConfig";
import { HomeBlock } from "../homeBlockData";
import { EditorLayout, ImagePicker, useBlockConfig } from "./EditorKit";

const initialConfig = (block: HomeBlock): BannerConfig => {
  const sample = block.code === "home-pc-builder";
  return {
    desktopImage: null,
    mobileImage: null,
    link: sample ? "/build-pc" : "",
    buttonLabel: sample ? "BẮT ĐẦU XÂY DỰNG" : "",
    alt: sample ? "HACOM PC Builder: tự chọn linh kiện và xây dựng cấu hình của riêng bạn" : "",
  };
};

const EditBanner = ({ block }: { block: HomeBlock }) => {
  const [config, setConfig] = useBlockConfig(block, () => initialConfig(block));
  // Banner mẫu là ảnh thiết kế: chỉ để xem, gỡ thì ẩn; không nằm trong config
  const [showSample, setShowSample] = useState(block.code === "home-pc-builder");
  const patch = (v: Partial<BannerConfig>) => setConfig((c) => ({ ...c, ...v }));
  const hasDesktop = !!config.desktopImage || showSample;

  return (
    <EditorLayout block={block}>
      <SectionCard
        title="Ảnh banner"
        right={
          <Button size="xs" variant="default">
            Chọn từ Danh sách banner
          </Button>
        }
      >
        <Flex wrap="wrap" gap={16} align="flex-start">
          <Box style={{ flex: "2 1 360px", minWidth: 0 }}>
            <ImagePicker
              label="Ảnh máy tính"
              src={config.desktopImage}
              imageId={showSample ? block.thumbId : undefined}
              crop={{ x: 0, y: 0, w: 1280, h: 427 }}
              onPick={(url) => patch({ desktopImage: url })}
              onClear={() => {
                setShowSample(false);
                patch({ desktopImage: null });
              }}
              height={180}
              maxWidth={9999}
            />
          </Box>
          <Box style={{ flex: "1 1 220px", minWidth: 0 }}>
            <ImagePicker
              label="Ảnh điện thoại"
              src={config.mobileImage}
              onPick={(url) => patch({ mobileImage: url })}
              onClear={() => patch({ mobileImage: null })}
              height={180}
              maxWidth={9999}
            />
          </Box>
        </Flex>
        {hasDesktop && !config.mobileImage && (
          <Alert color="orange" variant="light" radius="sm" p={10}>
            <Text fz={13}>
              Chưa có ảnh điện thoại. Trên điện thoại, web sẽ thu nhỏ ảnh máy
              tính và chữ trên banner sẽ rất nhỏ.
            </Text>
          </Alert>
        )}
      </SectionCard>

      <SectionCard title="Liên kết và nút">
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing={12}>
          <TextInput
            label="Link khi bấm"
            value={config.link}
            onChange={(e) => patch({ link: e.currentTarget.value })}
          />
          <TextInput
            label="Nhãn nút"
            description="Nút nằm trên ảnh; để trống nếu chữ nút đã có trong ảnh."
            inputWrapperOrder={["label", "input", "description"]}
            value={config.buttonLabel}
            onChange={(e) => patch({ buttonLabel: e.currentTarget.value })}
          />
        </SimpleGrid>
        <TextInput
          label="Mô tả ảnh"
          description="Dùng cho người đọc màn hình và SEO."
          inputWrapperOrder={["label", "input", "description"]}
          value={config.alt}
          onChange={(e) => patch({ alt: e.currentTarget.value })}
        />
        <Group>
          <Text fz={12} c="var(--hb-muted)">
            Lịch hiển thị riêng của banner đặt ở tab Hiển thị và lịch.
          </Text>
        </Group>
      </SectionCard>
    </EditorLayout>
  );
};

export default EditBanner;
